import ButtonT from '@components/tailwind-components/Button/ButtonT';
import SelectInputT from '@components/tailwind-components/Input/SelectInputT';
import LabelT from '@components/tailwind-components/Label/LabelT';
import { TIMEZONES } from '@conversed/shared/src/central/constants/timezones';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTimezone } from '../../../../hooks/flow/timezone/useTimezone';
import { useTimezoneActions } from '../../../../hooks/flow/timezone/useTimezoneActions';
import { useModal } from '../../../../hooks/modal/useModal';

interface TTimezone {
  value: string;
  description: string;
}

export const ManageTimezoneModal = () => {
  const { timezone } = useTimezone();
  const { updateTimezone } = useTimezoneActions();
  const { t } = useTranslation();
  const { hideModal } = useModal();

  const hideAndSubmit = (data: TTimezone) => {
    updateTimezone(data.value);
    hideModal();
  };

  const { handleSubmit, control } = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      value: timezone,
      description: timezone,
    },
  });

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <LabelT
              text={t('settings.webclient.config.form.config.timezone')}
            />
            <div className='mt-1'>
              <SelectInputT
                field={'value'}
                values={TIMEZONES}
                control={control}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
